import { Reveal } from "./motion";
import { IMAGES } from "@/lib/product";

const CHAPTERS = [
  {
    num: "01",
    kicker: "The Problem",
    title: "THE 2PM COLLAPSE.",
    body: "Regular coffee spikes you hard, then drops you harder. Jitters, anxiety, then the crash — right when you need to close the deal, hit the set, or ship the code. You're not tired. You're overcaffeinated and under-fueled.",
    img: IMAGES.espresso,
    align: "left",
  },
  {
    num: "02",
    kicker: "The Hack",
    title: "FUNCTIONAL MUSHROOMS.",
    body: "Lion's Mane for razor focus. Cordyceps for clean endurance. Chaga to buffer the stress response. Blended into a smooth dark roast so your energy climbs and holds — instead of spiking and dying.",
    img: IMAGES.mushroom,
    align: "right",
  },
  {
    num: "03",
    kicker: "The Wake-Up",
    title: "YOU, OVERCLOCKED.",
    body: "One cup. Six hours of locked-in, jitter-free output. This is the unfair advantage every founder, lifter and operator has been chasing. This is God Mode — and it comes in a bag.",
    img: IMAGES.ropes,
    align: "left",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32"
    >
      <Reveal>
        <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">
          The Manifesto
        </p>
        <h2 className="max-w-3xl font-display text-5xl uppercase leading-[0.9] tracking-tight sm:text-7xl">
          Coffee was <span className="text-zinc-600">broken.</span> So we
          rebuilt it.
        </h2>
      </Reveal>

      <div className="mt-16 flex flex-col gap-20 sm:mt-24 sm:gap-28">
        {CHAPTERS.map((c) => (
          <div
            key={c.num}
            className={`grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-16 ${
              c.align === "right" ? "lg:[direction:rtl]" : ""
            }`}
          >
            <div className="lg:col-span-6 lg:[direction:ltr]">
              <Reveal>
                <div className="overflow-hidden border border-zinc-800">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="h-[340px] w-full object-cover grayscale transition-all duration-700 hover:grayscale-0 sm:h-[440px]"
                  />
                </div>
              </Reveal>
            </div>
            <div className="lg:col-span-6 lg:[direction:ltr]">
              <Reveal delay={0.1}>
                <div className="flex items-baseline gap-4">
                  <span className="font-display text-6xl leading-none text-blaze sm:text-8xl">
                    {c.num}
                  </span>
                  <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">
                    {c.kicker}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-4xl uppercase leading-none tracking-tight sm:text-5xl">
                  {c.title}
                </h3>
                <p className="mt-5 max-w-lg text-base leading-relaxed text-zinc-400 sm:text-lg">
                  {c.body}
                </p>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
